
import angular from 'angular';
import dropdown from 'angular-ui-bootstrap/src/dropdown';

export default angular
  .module('atex.code.components', [dropdown])
  .name;
